export default __webpack_public_path__ + "static/media/logoNewLight.782640cb.svg";